// market — en. Part of the en i18n bundle; merged by ./index.js

export default {
  loading: 'Loading...',
  marketTitle: 'Market',
  marketSubtitle: 'Every product from our verified sellers — always open, no waiting.',
  bestDealToday: '⚡ Best Deal Today',
  bestDealsWeek: '🏆 Best Deals This Week',
  endsIn: 'Ends in',
// Bazaar & Market filter UI,
  clearAll: 'Clear All',
  searchLabel: 'Search',
  availability: 'Availability',
  inStockOnly: 'In Stock Only',
  allLocations: 'All Locations',
  sellers: 'Sellers',
  applyFilters: 'Apply Filters',
  sortDefault: 'Sort: Default',
  sortNewest: 'Newest First',
  sortPriceAsc: 'Price: Low \u2192 High',
  sortPriceDesc: 'Price: High \u2192 Low',
  sortNameAsc: 'Name: A \u2192 Z',
  statProducts: 'Products',
  statCategories: 'Categories',
  statCities: 'Cities',
  subcategoriesLabel: 'Subcategories:',
  all: 'All',
  resultsNone: 'No products match the current filters',
  resultsCount: (n) => `${n} products`,
  resultsCountOf: (a, b) => `${a} of ${b} products`,
  priceUnder: (a) => `Under ${a} Birr`,
  priceBand: (a, b) => `${a} \u2013 ${b} Birr`,
  priceOver: (a) => `Over ${a} Birr`,
  gridView: 'Grid view',
  listView: 'List view',
  scrollCatLeft: 'Scroll categories left',
  scrollCatRight: 'Scroll categories right',
  marketPlaceWord: 'Place',
  marketTagline: 'Every approved product in one place \u2014 filter by category or location.',
  comingSoon: 'Coming Soon',
  openNow: 'Open',
  closedNow: 'Closed',
// Bazaar open/closed + countdown,
  opensIn: '⏳ Opens In',
  closesIn: '· Closes in',
  nextBazaar: 'Next Bazaar',
  scheduledByAdmin: 'Scheduled by the admin',
  lastUpdated: 'Last updated',
  mpCatGridTitle: 'Shop by Category',
  mpCatGridViewAll: 'View All',
  signInToAdd: 'Please sign in to add items to your wishlist.',
  signInRequired: 'Sign In Required',
  wishlistLoginDesc: 'You need to be logged in to add items to your wishlist and start shopping.',
  cancel: 'Cancel',
  soldOut: 'Sold Out',
  bundle: 'BUNDLE',
  addedToWishlist: (name) => '❤️ ${name} added to wishlist!',
  searchProducts: 'Search products...',
  noResults: 'No products found.',
};

